import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../store';
import PricePeriod from './PricePeriod';
import ConnectedTabs from "./ConnectedTabs";
import { TabLink, TabContent } from "react-tabs-redux";
import * as Styles from '../styles/baseStyle';
import { getText } from '../utils/texts';
import HelpHeader from './HelpHeader';
import OfferPromo from './OfferPromo';

type PromotionsProps = PromotionsOwnProps;

interface PromotionsOwnProps {
    selectedTab: string;
}

const tabHeadStyle: React.CSSProperties = { padding: "5px 20px" };

class PromotionByPeriods extends React.Component<PromotionsProps, {}> {
    public render() {
        return (
            <div style={{height: "100%"}}>
                    <div className="card" style={{ ...Styles.cardStyle,  ...Styles.pageTitle}}>
                        <div style={{paddingRight: '2%'}}>
                        {getText("PricePeriodTitle")} {getText("PricePeriodByPeriod")}
                        </div>
                       
                </div>
                <PricePeriod />
            </div>
        );
    }
}

export default connect((state: ApplicationState) => ({

} as PromotionsOwnProps), null)(PromotionByPeriods);